// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f276f886","732":"7144b75d","977":"615f2565"}[chunkId] + ".chunk.js";
};